import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { User } from '../entity/user';

@Component({
  selector: 'user',
  templateUrl: './user.component.html'
})
export class UserComponent {
  currentUser: User = null;

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    if(this.authenticationService.isAuthenticated()){
      this.currentUser = this.authenticationService.getCurrentUser();
    }    
    this.authenticationService.userChanged$.subscribe(user => this.onUserChanged(user));
  }

  private onUserChanged(user: User): void {
    this.currentUser = user;
  }

  logout(event): void {
    event.preventDefault();
    this.authenticationService.logout()
      .then(function(disconnected){
        if(disconnected){
          this.router.navigate(['login']);
        }
      }.bind(this));
  }
}


// WEBPACK FOOTER //
// ./src/app/user/user.component.ts